import { Component, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { AnalyticsService, NgxBarGroup, VideoViewsRequest } from '../../services/api';

@Component({
  selector: 'app-youtube-video-views',
  templateUrl: './youtube-video-views.component.html',
  styleUrls: ['./youtube-video-views.component.scss']
})
export class YoutubeVideoViewsComponent implements OnInit, OnChanges {
  @Input() viewsize: [number, number] = [1000, 520];
  @Input() disableResize: boolean = false;
  @Input() startDate?: Date | null;
  @Input() endDate?: Date | null;

  showXAxis = true;
  showYAxis = true;
  showLegend = false;
  xAxisLabel = 'Views';
  yAxisLabel = 'Video';

  // Computed based on tile mode
  get showXAxisLabel(): boolean {
    return !this.disableResize;
  }
  get showYAxisLabel(): boolean {
    return !this.disableResize;
  }
  get yAxisMaxLabelLength(): number {
    return this.disableResize ? 25 : 50;
  }

  chartData: NgxBarGroup[] = [];
  loading = false;
  errorMsg = '';

  constructor(private readonly analyticsService: AnalyticsService) {}

  ngOnInit(): void {
    this.fetchVideoViews();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['startDate'] || changes['endDate']) {
      this.fetchVideoViews();
    }
  }

  private fetchVideoViews(): void {
    this.loading = true;
    this.errorMsg = '';

    const body: VideoViewsRequest = {
      topN: 10,
      metric: 'total',
      startDate: this.startDate ? this.startDate.toISOString() : undefined,
      endDate: this.endDate ? this.endDate.toISOString() : undefined
    };

    this.analyticsService.analyticsGetVideoViewsReportPost(body).subscribe({
      next: data => {
        this.chartData = data ?? [];
        this.loading = false;
        if (this.disableResize) {
          setTimeout(() => {
            this.viewsize = [this.viewsize[0], this.viewsize[1]];
          });
        }
      },
      error: err => {
        console.error(err);
        this.errorMsg = 'Failed to load YouTube video views.';
        this.loading = false;
      }
    });
  }

  onResize(event: any) {
    if (this.disableResize) return;
    const w = event?.target?.innerWidth ?? 1200;
    this.viewsize = [Math.max(720, Math.floor(w * 0.8)), 520];
  }
}
